import { render } from "./OrientationAward.vue?vue&type=template&id=4b6c09ec"
import script from "./OrientationAward.vue?vue&type=script&lang=js"
export * from "./OrientationAward.vue?vue&type=script&lang=js"

import "./OrientationAward.vue?vue&type=style&index=0&id=4b6c09ec&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__